module.exports = __webpack_public_path__ + "static/media/PM94.e7190280.png";